import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const testimonials = [
  {
    id: 1,
    name: 'James Wilson',
    location: 'Londres, Reino Unido',
    image: 'https://public.readdy.ai/ai/img_res/7a42f6e449d01bb4d477cc34fccb7bfe.jpg',
    rating: 5,
    text: 'testimonial1',
    date: 'testimonialDate1'
  },
  {
    id: 2,
    name: 'Maria Santos',
    location: 'Lisboa, Portugal',
    image: 'https://readdy.ai/api/search-image?query=elegant%20portuguese%20businesswoman%20in%20her%2030s%20wearing%20professional%20attire%20warm%20smile%20corporate%20headshot%20photo%20clean%20white%20background%20high%20quality%20portrait%20photography&width=400&height=400&seq=testimonial2&orientation=squarish',
    rating: 5,
    text: 'testimonial2',
    date: 'testimonialDate2'
  },
  {
    id: 3,
    name: 'Hans Mueller',
    location: 'Berlim, Alemanha',
    image: 'https://readdy.ai/api/search-image?query=friendly%20german%20family%20man%20in%20his%2040s%20wearing%20casual%20smart%20clothing%20genuine%20smile%20portrait%20photo%20clean%20white%20background%20high%20quality%20photography&width=400&height=400&seq=testimonial3&orientation=squarish',
    rating: 5,
    text: 'testimonial3',
    date: 'testimonialDate3'
  },
  {
    id: 4,
    name: 'Sophie Dubois',
    location: 'Paris, França',
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20french%20woman%20in%20her%2035s%20wearing%20elegant%20casual%20outfit%20warm%20smile%20portrait%20photo%20clean%20white%20background%20high%20quality%20photography&width=400&height=400&seq=testimonial4&orientation=squarish',
    rating: 5,
    text: 'testimonial4',
    date: 'testimonialDate4'
  },
  {
    id: 5,
    name: 'Ana Rodrigues',
    location: 'Porto, Portugal',
    image: 'https://readdy.ai/api/search-image?query=young%20portuguese%20professional%20woman%20in%20her%2030s%20wearing%20modern%20business%20casual%20friendly%20smile%20portrait%20photo%20clean%20white%20background%20high%20quality%20photography&width=400&height=400&seq=testimonial5&orientation=squarish',
    rating: 5,
    text: 'testimonial5',
    date: 'testimonialDate5'
  },
  {
    id: 6,
    name: 'Robert Johnson',
    location: 'Manchester, Reino Unido',
    image: 'https://readdy.ai/api/search-image?query=confident%20british%20executive%20man%20in%20his%2045s%20wearing%20business%20suit%20professional%20smile%20corporate%20headshot%20clean%20white%20background%20high%20quality%20portrait%20photography&width=400&height=400&seq=testimonial6&orientation=squarish',
    rating: 5,
    text: 'testimonial6',
    date: 'testimonialDate6'
  }
];

export default function Testimonials() {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 6000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  const handleNext = () => {
    if (!isAnimating) {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % testimonials.length);
        setIsAnimating(false);
      }, 500);
    }
  };

  const handlePrev = () => {
    if (!isAnimating) {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
        setIsAnimating(false);
      }, 500);
    }
  };

  const handleDotClick = (index: number) => {
    if (!isAnimating && index !== currentIndex) {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentIndex(index);
        setIsAnimating(false);
      }, 500);
    }
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="py-24 bg-gradient-to-br from-orange-50 via-white to-orange-50 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-orange-100 rounded-full filter blur-3xl opacity-30 -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-100 rounded-full filter blur-3xl opacity-30 translate-x-1/2 translate-y-1/2"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('testimonialsTitle')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('testimonialsSubtitle')}
          </p>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-8 mb-16 animate-slide-up">
          <div className="flex flex-col items-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="text-4xl font-bold text-orange-500 mb-2">4.9/5</div>
            <div className="flex gap-1 mb-2">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
              ))}
            </div>
            <div className="text-sm text-gray-600">{t('averageRating')}</div>
          </div>

          <div className="flex flex-col items-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="text-4xl font-bold text-orange-500 mb-2">5000+</div>
            <div className="flex gap-1 mb-2">
              <i className="ri-user-heart-line text-orange-500 text-2xl"></i>
            </div>
            <div className="text-sm text-gray-600">{t('happyClients')}</div>
          </div>

          <div className="flex flex-col items-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="text-4xl font-bold text-orange-500 mb-2">100%</div>
            <div className="flex gap-1 mb-2">
              <i className="ri-verified-badge-line text-green-500 text-2xl"></i>
            </div>
            <div className="text-sm text-gray-600">{t('verified')}</div>
          </div>

          <div className="flex flex-col items-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="text-4xl font-bold text-orange-500 mb-2">15+</div>
            <div className="flex gap-1 mb-2">
              <i className="ri-trophy-line text-orange-500 text-2xl"></i>
            </div>
            <div className="text-sm text-gray-600">{t('awards')}</div>
          </div>
        </div>

        {/* Testimonial Card */}
        <div className="max-w-5xl mx-auto">
          <div className={`bg-white rounded-3xl shadow-2xl p-8 md:p-12 transition-all duration-500 ${isAnimating ? 'opacity-0 scale-95' : 'opacity-100 scale-100'}`}>
            <div className="flex flex-col md:flex-row items-center gap-8">
              {/* Image */}
              <div className="flex-shrink-0 animate-scale-in">
                <div className="relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-orange-400 to-orange-600 rounded-full blur-xl opacity-30"></div>
                  <img
                    src={currentTestimonial.image}
                    alt={currentTestimonial.name}
                    className="relative w-32 h-32 md:w-40 md:h-40 rounded-full object-cover border-4 border-white shadow-xl"
                  />
                  <div className="absolute -bottom-2 -right-2 bg-orange-500 text-white rounded-full p-3 shadow-lg">
                    <i className="ri-double-quotes-r text-2xl"></i>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 text-center md:text-left">
                {/* Stars */}
                <div className="flex justify-center md:justify-start gap-1 mb-4 animate-fade-in">
                  {[...Array(currentTestimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-2xl animate-bounce" style={{ animationDelay: `${i * 0.1}s` }}></i>
                  ))}
                </div>

                {/* Text */}
                <p className="text-lg md:text-xl text-gray-700 mb-6 leading-relaxed italic">
                  "{t(currentTestimonial.text)}"
                </p>

                {/* Author Info */}
                <div className="flex flex-col md:flex-row items-center md:items-start gap-4">
                  <div>
                    <h4 className="text-xl font-bold text-gray-900">{currentTestimonial.name}</h4>
                    <p className="text-gray-600 flex items-center justify-center md:justify-start gap-2">
                      <i className="ri-map-pin-line text-orange-500"></i>
                      {currentTestimonial.location}
                    </p>
                    <p className="text-sm text-gray-500 mt-1">{t(currentTestimonial.date)}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-6 mt-8">
            {/* Previous Button */}
            <button
              onClick={handlePrev}
              className="w-12 h-12 flex items-center justify-center bg-white hover:bg-orange-500 text-gray-700 hover:text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 cursor-pointer"
              aria-label="Previous testimonial"
            >
              <i className="ri-arrow-left-s-line text-2xl"></i>
            </button>

            {/* Dots */}
            <div className="flex gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => handleDotClick(index)}
                  className={`h-3 rounded-full transition-all duration-300 cursor-pointer ${
                    index === currentIndex
                      ? 'w-8 bg-orange-500'
                      : 'w-3 bg-gray-300 hover:bg-orange-300'
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>

            {/* Next Button */}
            <button
              onClick={handleNext}
              className="w-12 h-12 flex items-center justify-center bg-white hover:bg-orange-500 text-gray-700 hover:text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 cursor-pointer"
              aria-label="Next testimonial"
            >
              <i className="ri-arrow-right-s-line text-2xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
